//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VALIDATION_STATUS from '@/constants/assigment-validation-status'
import SidebarContainer from './SidebarContainer.vue'
import CollaboratorItem from './Collaborator/CollaboratorItem.vue'
export default {
  components: {
    SidebarContainer,
    CollaboratorItem,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    assignments: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      open: this.value,
    }
  },
  watch: {
    value(newValue) {
      this.open = newValue
    },
    open(newValue) {
      this.$emit('input', newValue)
    },
  },
  methods: {
    handleCollaboratorClick(validation) {
      if (
        validation.validation_status === VALIDATION_STATUS.PENDING ||
        validation.validation_status === VALIDATION_STATUS.READY_FOR_VALIDATION
      ) {
        return
      }
      this.$emit('collaborator-click', validation)
      this.open = false
    },
  },
}
